import React, { useState, useEffect } from "react";
import "../TypeOfCrops/TypeOfCrops.css";
import { Box, Grid, Typography } from "@mui/material";
import { dashboardIcon } from "../../config/images";
import { useNavigate } from "react-router-dom";
import { getTypeOfMachinery } from "../../config/services";
import translations from "../../config/language";

const Machinery = () => {
  const navigate = useNavigate();

  const [machineryData, setMachineryData] = useState([]);

  useEffect(() => {
    handleMachineryData();
  }, []);

  const handleMachineryData = async () => {
    try {
      const resp = await getTypeOfMachinery();
      if (resp.status == 200 || resp.status == 201) {
        setMachineryData(resp.data.results.payload);
      }
    } catch (error) {
      setMachineryData([]);
    }
  };
  const language = process.env.REACT_APP_LANGUAGE;

  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center">
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={dashboardIcon.machineryImage}
              alt=""
            // style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].typesOfMachinery}
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={3} className="p-3">
          {machineryData.map((e) => {
            return (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <Box
                    className="crops-data d-flex justify-content-between align-items-center"
                    onClick={() =>
                      navigate(`/machinery/machinery-data/${e.id}`, {
                        state: { name: e.name },
                      })
                    }
                  >
                    <Typography variant="h6">{e.name}</Typography>
                    <Typography variant="h5">
                      {String(e?.counts).padStart(2, "0")}
                    </Typography>
                  </Box>
                </Grid>
              </>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export default Machinery;
